'use client';
import React, { useState } from 'react';
import styles from '../style.module.scss';
import Image from 'next/image';
import { IProduct } from '@mybestbrands/types';
import { useTranslation } from 'next-i18next';
import ClickOutCTA from '@/app/ui/components/clickOutCTA';

interface CouponViewProps {
  onClose: () => void;
  item: IProduct;
  locale: string;
  isDetail?: boolean;
}

const CouponOverlay = ({ onClose, item, locale, isDetail }: CouponViewProps) => {
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation(['common']);
  const hasDiscountCoupon = item.couponPrice && item.couponPrice !== item.price;
  const couponCode = item.priorityCoupon?.code || '';
  const couponCodeCheck = (code: string): boolean => code.length > 0 && !code.includes(' ');

  const handleOverlayClick = (event: React.MouseEvent) => {
    // Prevent the click event from bubbling up to the parent element
    event.stopPropagation();
  };

  const handleCopyCoupon = (code: string) => {
    if (couponCodeCheck(code)) {
      navigator.clipboard.writeText(code).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  };

  return (
    <>
      {isDetail && <div className={styles['overlayMobileBackground']} onClick={onClose}></div>}
      <div className={styles[isDetail ? 'pdpOverlay' : 'overlay']} onClick={handleOverlayClick}>
        <div className={styles['closeBtn']} onClick={onClose}>
          <Image
            width={12}
            height={12}
            className={'cursor-pointer'}
            src="/intstatic/icons/close-x-white.svg"
            alt="close"
          />
        </div>
        <div className={`mx-2 ${styles['overlayContent']}`}>
          {couponCodeCheck(couponCode) ? (
            <div className={styles['couponSubtitle']} style={isDetail ? { marginBottom: '2rem' } : {}}>
              {t('REDEEM_COUPON_AT_SHOP').replace('##RETAILER##', item.retailerName.toUpperCase())}
            </div>
          ) : (
            <div className={styles['couponSubtitle']}>
              {t('common:VOUCHER_SUBTITLE_WITHOUT_CODE').replace('##RETAILER##', item.retailerName.toUpperCase())}
            </div>
          )}
          {couponCodeCheck(couponCode) && (
            <>
              <div className={`mb-1 ${styles['title']}`}>{t('COUPON_CODE')}</div>
              <div style={{ display: 'inline-flex', position: 'relative' }}>
                <div className={styles['couponBox']} onClick={() => handleCopyCoupon(couponCode)}>
                  <span className={`px-4 ${styles['size']}`}>{couponCode}</span>
                </div>
                <span className={styles['copyCode']}>
                  <Image
                    onClick={() => handleCopyCoupon(couponCode)}
                    height={14}
                    width={10}
                    src={`/intstatic/icons/${copied ? 'white-checkmark' : 'white-copy-icon'}.svg`}
                    alt={'copy code'}
                  />
                </span>
              </div>
            </>
          )}
          <div className={styles['couponTitle']} style={isDetail ? { marginBottom: '2rem', marginTop: '1rem' } : {}}>
            {item.priorityCoupon?.title || ''}
          </div>
          <ClickOutCTA product={item} locale={locale}>
            <div className={styles['shopBtn']} data-testid="shop-button">
              {t('TO').toUpperCase()}
              <b className="ms-1">{item.retailerName.toUpperCase()}</b>
            </div>
          </ClickOutCTA>
        </div>
      </div>
    </>
  );
};

export default CouponOverlay;
